import type { Lang, Localized } from '@/data/types';

export const LANG_NAMES: Record<string, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  pt: 'Português',
};
/** Flag emoji per language, for the language switcher. */
export const LANG_FLAGS: Record<Lang, string> = {
  fr: '🇫🇷',
  en: '🇬🇧',
  es: '🇪🇸',
  pt: '🇵🇹',
};
export const LANG_ORDER: Lang[] = ['es', 'en', 'pt', 'fr'];

/** Resolve a string-or-Localized value for the active language, with fallbacks. */
export function tr(value: string | Localized | undefined, lang: Lang): string {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  return value[lang] || value.en || value.es || value.fr || value.pt || '';
}
